import { Address } from "viem";

import { CHAIN_ID } from "@/constants/chains";

import { isVercelEnv } from "../rpc/near";

interface Config {
  apiURL: string;
  apiStaging: string;
  mixpanelToken: string;
  trustScoreStartDate: number;
  near: Readonly<{
    totalScoreContract: string;
    score: string;
    nft: string;
    nodeUrls: Array<string>;
    airdrop: string;
    hapiTokenAddress: string;
  }>;
  evm: Readonly<{
    attestation: Readonly<Record<CHAIN_ID, { schemaId: Address; portalId: Address; moduleId: Address }>>;
    native: Readonly<Record<CHAIN_ID, { contractId: Address }>>;
  }>;
  ton: Readonly<{
    score: string;
    nodeUrl: string;
    apiKey: string;
  }>;
  solana: {
    attestation: string;
  };
  stellar: { attestation: string; stellarXLM: string; rpcUrl: string };
}

export const config: Readonly<Config> = {
  apiURL: "https://score-be.hapi.mobi",
  apiStaging: "https://hapi-one.stage.hapi.farm",
  mixpanelToken: "2502832ae50f8859884965ac20f1f888",
  trustScoreStartDate: 1737453600000,
  near: {
    totalScoreContract: "total-score-event.hapiprotocol.near",
    score: "score-v1.hapiprotocol.near",
    nft: "hapi-nearonaut.near",
    nodeUrls: ["https://rpc.mainnet.pagoda.co", "https://rpc.near.org", "https://rpc.mainnet.near.org"],
    airdrop: isVercelEnv ? "bank.burntest.near" : "airdrop.burntest.near",
    hapiTokenAddress: "d9c2d319cd7e6177336b0a9c93c21cb48d84fb54.factory.bridge.near",
  },
  evm: {
    attestation: {
      [CHAIN_ID.BASE]: {
        schemaId: "0x1a86eebc5dd536ebf5b3c59302b7089648539122c56c14c8cd6bb2fb8e3c2f84" as Address,
        portalId: "0x8d3bc9Ff4e55d09EE547A076D73b50faa4C79C1e" as Address,
        moduleId: "0x3eAE5566344e99A9D9c515332883Fd30b5184701" as Address,
      },
      [CHAIN_ID.LINEA]: {
        schemaId: "0x1a86eebc5dd536ebf5b3c59302b7089648539122c56c14c8cd6bb2fb8e3c2f84" as Address,
        portalId: "0x3853D7CEE9a825A24F48f7e1f6aaEcB91Ba3683f" as Address,
        moduleId: "0x5AcF01D27F85DA54d34E18A25731f87528f97506" as Address,
      },
      [CHAIN_ID.BSC]: {
        schemaId: "0x1a86eebc5dd536ebf5b3c59302b7089648539122c56c14c8cd6bb2fb8e3c2f84" as Address,
        portalId: "0x0b4d4fbde2caf7df2bdb1bfe3fe941ab79f2275f" as Address,
        moduleId: "0x0fEbD23cbefeDF1A65d9FE51a0b6d63C3a477e05" as Address,
      },
      [CHAIN_ID.ARBITRUM]: {
        schemaId: "0x1a86eebc5dd536ebf5b3c59302b7089648539122c56c14c8cd6bb2fb8e3c2f84" as Address,
        portalId: "0x96b3B714A4339b12725f1AFefd6BD844F7b40A30" as Address,
        moduleId: "0xa87B3E7e3bBe0E721309119B610B32683b61db08" as Address,
      },
    },
    native: {
      [CHAIN_ID.ETHEREUM]: {
        contractId: "0x63253e3352c0CAe9F6ee64E61ed461AE23F9c8b6" as Address,
      },
    },
  },
  ton: {
    score: "EQAvUDmCAM9Zl_i3rXeYA2n-s_uhM4rTBhzAQUeJIxEOB62i",
    nodeUrl: "https://tonapi.io",
    apiKey: "AGJ6LLDZTHT774IAAAACH7HUVRAYFMQL4SK3FC3ET2FRNLGHFGOOV7U5V4K6BFOGJ6OPLUQ",
  },
  solana: {
    attestation: "4LAmGSWFTqnzNif9745G2W9u4R84Anr7pw4jF2wssGgp",
  },
  stellar: {
    attestation: "CDQCZAMYQ42NAHF5RK5D33FEFGSXTWJ2PSH3D54VAEYNJEEJKD2M7WG7",
    stellarXLM: "CAS3J7GYLGXMF6TDJBBYYSE3HQ6BBSMLNUQ34T6TZMYMW2EVH34XOWMA",
    rpcUrl: "https://mainnet.sorobanrpc.com",
  },
};
